

const FINANCIAL_FLOW = 'FINANCIAL_FLOW';
const NON_FINANCIAL_FLOW_SWITCHABLE = 'NON_FINANCIAL_FLOW_SWITCHABLE';
const NON_FINANCIAL_FLOW_NON_SWITCHABLE = 'NON_FINANCIAL_FLOW_NON_SWITCHABLE';

export enum SsapFlowType {
    FINANCIAL_FLOW = 'FINANCIAL_FLOW',
    NON_FINANCIAL_FLOW_SWITCHABLE = 'NON_FINANCIAL_FLOW_SWITCHABLE',
    NON_FINANCIAL_FLOW_NON_SWITCHABLE = 'NON_FINANCIAL_FLOW_NON_SWITCHABLE'
}

export const flowTypes = {
    FINANCIAL_FLOW,
    NON_FINANCIAL_FLOW_SWITCHABLE,
    NON_FINANCIAL_FLOW_NON_SWITCHABLE
};